import * as React from 'react';
import Countries from '@ui/scenes/Countries';

const CountriesPage = () => (
  <div className="countries-page">
    <Countries />
  </div>
);

export default CountriesPage;



// WEBPACK FOOTER //
// ./src/pages/Countries/Countries.tsx